import mixins from 'synergycms_core/src/less/mixins';

export default {
  resumeSimpleContainer: {},
  resumeSimple: {},
  customer: {},
  title: {},
  bookIcon: {},
  body: {},
  hotelData: {},
  email: {},
  simpleBookingInfo: {},
  locator: {},
  locatorBox: {},
  locatorTitle: {},
  locatorValue: {},
  pinTitle: {},
  resumeFullContainer: {},
  resumeFull: {},
  resume: {},
  bookingResume: {},
  hotelInfo: {},
  stars: {},
  hotelTitle: {},
  hotelAddress: {},
  bookingDetailContainer: {},
  bookingDetail: {},
  bookingDetailRow: {},
  bookingDetailColumn: {},
  bookingDetailColumn2: {},
  adultOccup: {},
  childOccup: {},
  roomDetailContainer: {},
  extraDetailContainer: {},
  extraDetail: {},
  extraDetailRow: {},
  extraName: {},
  textWarning: {},
  extraPrice: {},
  actionsContainer: {},
  summary: {},
  actions: {},
  actionsGrid: {},
  actionContainer: {},
  actionIconContainer: {},
  actionIcon: {},
  roomsFullContainer: {},
  roomsFull: {},
  roomsResume: {},
  roomsPhotos: {},
  roomsInfo: {},
  roomDescriptionMargin:{},
  buttonImage: {},
  roomsTitle: {},
  paymentAndPenaltiesContainer: {},
  paymentAndPenalties: {},
  penaltiesBox: {},
  penaltiesTitle: {},
  penaltiesText: {},
  paymentBox: {},
  paymentTitle: {},
  paymentText: {},
  hotelInfoContainer: {},
  hotelInfoBox: {},
  hotelImage: {},
  hotelHeader: {},
  hotelOpinion: {},
  hotelName: {},
  smile: {},
  hotelInfoAddress: {},
  hotelDataTable: {},
  hotelDataRow: {},
  hotelDataCell: {},
  hotelMap: {},
  gmapMarkerIcon: {},
  hotelOtherInfo: {},
  hotelOtherInfoTitle: {},
  hotelOtherInfoText: {},
  flightContainer: {},
  flightBox: {},
  flightInfo: {},
  flightTitle: {},
  flightText: {},
  flightButton: {},
  corporateContainer: {},
  corporateBox: {},
  corporateTitle: {},
  corporateSupTitle: {},
  corporateList: {},
  corporateItem: {},
  corporateIcon: {},
  webAdvantagesContainer: {},
  webAdvantagesBox: {},
  webAdvantagesTitle: {},
  webAdvantagesTitleHeader: {},
  webAdvantagesList: {},
  webAdvantagesItem: {},
  webAdvantagesIcon: {},
  itemBreakfast: {},
  itemCheckin: {},
  itemWelcomeWater: {},
  webAdvantagesTitleNoLogo: {},
  userNotesContainer: {},
  userNotes: {},
  userNotesTitle: {},
  userNotesText: {},
  mapImageConfirmation: {},
  header: {},
  confirmationContainer:{},
  confirmationBox:{},
  confirmationContent:{},
  confirmationFooter:{},
  confirmationButton:{},
  confirmationLogo:{},
  confirmationLogoSvg:{},
  confirmationList:{},
  confirmationElement:{},
  confirmationElementSvg:{},
  confirmationFooterCell:{},
  confirmationFooterButton:{},
  confirmationFooterButtonText:{},
  firstLetterUpper:{},
  activateTextContainer:{},
  activateTitle:{},
  activateSubTitle:{},
  webAdvantages:{},
  activateText:{},
  bookerSendError: {},
  bookerSendSucces: {},
  defaultStyle: {
    '& $resumeSimpleContainer': {
      font: data => '300 13px ' + data.fontFamily1,
      paddingBottom: '20px',
      '& $resumeSimple': {
        borderBottom: data => '3px solid ' + data.mainColor,
        background: '#fff',
        paddingBottom: '12px',
        '& $customer': {
          padding: '20px 10px 18px',
          '& $title': {
            marginBottom: '13px',
            color: '#5ca70a',
            font: data => '24px/1.13 ' + data.fontFamily1,
            '& > div': {
              textAlign: 'center',
              '@media (min-width: 801px), print': {
                textAlign: 'left'
              },
              '&:lang(ar)': {
                '@media (min-width: 801px)': {
                  textAlign: 'right'
                }
              }
            },
            '& $bookIcon': {
              width: '50px',
              height: '50px',
              fill: data => data.secondColor,
              display: 'block',
              margin: '0 auto',
              '@media (min-width: 801px)': {
                width: '60px',
                height: '60px',
                position: 'absolute',
                left: '0',
                top: '0',
              },
              '&:lang(ar)': {
                '@media (min-width: 801px)': {
                  left: 'auto',
                  right: 0
                }
              }
            },
            '@media (min-width: 801px), print': {
              display: 'block',
              position: 'relative',
              paddingLeft: '80px',
              minHeight: '60px',
              '&:lang(ar)': {
                paddingRight: '80px',
                paddingLeft: '0',
              },
            },
          },
          '& $body': {
            textAlign: 'center',
            '& $email': {
              padding: '0',
              textDecoration: 'none',
              margin: '0 0 0 3px',
              color: '#000',
              fontWeight: '500',
              border: '0',
              '&:lang(ar)': {
                marginRight: '3px',
                marginLeft: 0
              }
            },
            '@media (min-width: 801px), print': {
              ...mixins.boxSizing('content-box'),
              marginRight: '100px',
              border: '0',
              color: 'inherit',
              padding: '0',
              textAlign: 'left'
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                textAlign: 'right',
                marginLeft: '100px',
                marginRight: 0
              }
            }
          },
          '@media (min-width: 801px), print': {
            display: 'table-cell',
            textAlign: 'left',
            verticalAlign: 'bottom',
            padding: '23px 0 0 20px'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px)': {
              paddingLeft: 0,
              paddingRight: '20px',
              textAlign: 'right'
            }
          }
        },
        '& $simpleBookingInfo': {
          '& $locator': {
            display: 'table',
            width: '100%',
            borderSpacing: '10px 0',
            border: '0',
            margin: '0',
            padding: '0',
            '& $locatorBox': {
              display: 'table-cell',
              border: '1px dashed #9e9e9e',
              verticalAlign: 'top',
              padding: '10px 6px 8px',
              textAlign: 'left',
              '&:lang(ar)': {
                textAlign: 'right'
              },
              '& $locatorTitle': {
                fontSize: '11px',
                color: '#9b9b9b',
                display: 'block',
                '@media (min-width: 801px), print': {
                  fontSize: '11px'
                }
              },
              '& $locatorValue': {
                fontSize: '18px',
                fontWeight: 'bold',
                wordBreak: 'break-word'
              },
              '& $pinTitle': {
                textTransform: 'uppercase'
              },
              '@media (min-width: 801px), print': {
                padding: '8px 12px'
              }
            },
            '&:lang(ar)': {
              direction: 'rtl',
            }
          },
          '@media (min-width: 801px), print': {
            display: 'table-cell',
            verticalAlign: 'bottom',
            paddingRight: '20px',
            width: '350px'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px)': {
              paddingRight: 0,
              paddingLeft: '20px'
            }
          }
        },
        '@media (min-width: 801px), print': {
          ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
          borderBottom: data => '3px solid ' + data.mainColor,
          paddingBottom: '30px',
          maxWidth: '1000px',
          margin: '0 auto',
          display: 'table',
          width: '100%',
          '&:lang(ar)': {
            direction: 'rtl',
          },
        }
      },
      '@media (min-width: 801px), print': {
        padding: '38px 10px 20px',
        font: data => '300 13px ' + data.fontFamily1,
        background: '#f1f1f1',
        textAlign: 'center'
      }
    },
    '& $resumeFullContainer': {
      font: data => '300 13px ' + data.fontFamily1,
      background: '#f1f1f1',
      textAlign: 'left',
      paddingBottom: '20px',
      '&:lang(ar)': {
        textAlign: 'right'
      },
      '& $resumeFull': {
        backgroundColor: '#fff',
        ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        ...mixins.boxSizing('content-box'),
        border: 0,
        color: 'inherit',
        padding: 0,
        '& $resume': {
          padding: '20px 0 0',
          '& $bookingResume': {
            '& > div': {
              paddingLeft: '20px',
              paddingRight: '20px',
              position: 'relative',
              '@media (min-width: 801px), print': {
                paddingLeft: '0',
                paddingRight: '0'
              }
            },
            '& > div:last-child': {
              '& > div': {
                '&:after': {
                  content: 'none'
                }
              }
            },
            '& $hotelInfo': {
              paddingBottom: '13px',
              '& $stars': {
                display: 'block',
                marginBottom: '3px',
                '@media (min-width: 801px), print': {
                  fontSize: '13px'
                }
              },
              '& $hotelTitle': {
                fontSize: '16px',
                fontWeight: '500',
                '@media (min-width: 801px), print': {
                  fontSize: '24px',
                  fontWeight: 'normal'
                }
              },
              '& $hotelAddress': {
                color: '#666',
                lineHeight: '1.38',
                '@media (min-width: 801px), print': {
                  fontSize: '13px'
                }
              },
              '&:after': {
                position: 'absolute',
                borderBottom: '1px solid #d8d8d8',
                left: '20px',
                right: '20px',
                content: "''",
                bottom: '0',
                '@media (min-width: 801px), print': {
                  content: 'none'
                }
              },
              '@media (min-width: 801px), print': {
                paddingBottom: '20px'
              }
            },
            '& $bookingDetailContainer': {
              '& $bookingDetail': {
                display: 'table',
                width: '100%',
                padding: '10px 0 15px',
                margin: '0',
                '@media (min-width: 801px), print': {
                  padding: 0
                }
              },
              '& $bookingDetailRow': {
                lineHeight: '1.85',
                display: 'table-row',
                listStyle: 'none',
                '& > *:nth-child(even)': {
                  paddingLeft: '10px',
                  textAlign: 'left',
                  '&:lang(ar)': {
                    textAlign: 'right',
                    paddingRight: '10px',
                    paddingLeft: 0
                  },
                },
                '& $bookingDetailColumn': {
                  display: 'table-cell',
                  fontSize: '13px',
                  '& > span': {
                    fontSize: '13px',
                    fontWeight: '500',
                    '@media (min-width: 801px), print': {
                      fontSize: '16px'
                    }
                  },
                  '@media (min-width: 801px), print': {
                    fontSize: '16px',
                    lineHeight: '1.85'
                  }
                },
                '& $bookingDetailColumn2': {
                  display: 'table-cell',
                  fontSize: '13px',
                  '& > span': {
                    '@media (min-width: 801px), print': {
                      fontSize: '16px'
                    }
                  },
                  '@media (min-width: 801px), print': {
                    fontSize: '16px',
                    lineHeight: '1.85'
                  }
                },
                '& $adultOccup': {
                  font: '15px/1px Icons',
                  color: data => data.mainColor,
                  lineHeight: '0',
                  display: 'inline-block',
                  marginRight: '2px',
                  marginTop: '-7px',
                  '&:lang(ar)': {
                    marginRight: 0,
                    marginLeft: '7px',
                    marginTop: '0',
                  },
                },
                '& $childOccup': {
                  left: '7px',
                  font: '10px/1px Icons',
                  color: data => data.mainColor,
                  '&:lang(ar)': {
                    right: '7px',
                    left: 'auto'
                  },
                },
                '&:lang(ar)': {
                  '&:last-of-type':{
                    '& $bookingDetailColumn2':{
                      display: 'flex',
                      alignItems: 'center',
                    }
                  }
                }
              },
              '&:after': {
                position: 'absolute',
                borderBottom: '1px solid #d8d8d8',
                left: '20px',
                right: '20px',
                content: "''",
                bottom: '0',
                '@media (min-width: 801px), print': {
                  left: 0,
                  right: 0
                }
              },
              '@media (min-width: 801px), print': {
                paddingBottom: '23px'
              },
              '&:lang(ar)': {
                direction: 'rtl',
              },
            },
            '& $roomDetailContainer': {
              '& > div': {
                '&:not(:last-of-type)': {
                  borderBottom: '1px solid #d8d8d8'
                },
                '&:after': {
                  position: 'absolute',
                  borderBottom: '1px solid #d8d8d8',
                  left: '20px',
                  right: '20px',
                  content: "''",
                  bottom: '0'
                }
              },
              '& $extraDetailContainer': {
                '& $extraDetail': {
                  border: '0',
                  color: 'inherit',
                  margin: '0',
                  padding: '10px 0 15px',
                  display: 'table',
                  width: '100%',
                  '& $extraDetailRow': {
                    listStyle: 'none',
                    display: 'table-row',
                    '& $extraName': {
                      display: 'table-cell',
                      width: '50%',
                      '& > span': {
                        fontSize: '13px'
                      },
                      '& > div': {
                        '& > span': {
                          fontSize: '13px',
                          '@media (min-width: 801px), print': {
                            fontSize: '16px'
                          }
                        }
                      },
                      '&:lang(ar)': {
                        order: '2',
                      },
                      '& $textWarning': {
                        display: 'block',
                        width: 'auto',
                        textAlign: 'left',
                        color: '#d0021b',
                        fontSize: '12px',
                      },
                    },
                    '& $extraPrice': {
                      display: 'table-cell',
                      paddingLeft: '10px',
                      textAlign: 'right',
                      '&:lang(ar)': {
                        textAlign: 'left',
                        paddingLeft: '0',
                        paddingRight: '10px',
                        order: '1',
                      },
                      '& > span': {
                        fontSize: '13px',
                        '@media (min-width: 801px), print': {
                          fontSize: '16px'
                        },
                        '&.styledShowPriceAs': {
                          fontSize: '13px'
                        }
                      },
                      '& > div': {
                        '& > span': {
                          fontSize: '13px'
                        }
                      }
                    },
                    '&:lang(ar)': {
                      display: 'flex',
                      justifyContent: 'space-between',
                  }
                  },
                  '@media (min-width: 801px), print': {
                    padding: '0'
                  }
                },
                '@media (min-width: 801px), print': {
                  padding: '17px 0 14px',
                  '&:last-of-type': {
                    paddingTop:'5px',
                    '&:lang(ar)': {
                      direction: 'rtl',
                    },
                  }
                }
              },
              '&:lang(ar)': {
                '&:last-of-type': {
                  '& $extraDetailRow':{
                    direction: 'ltr',
                  }
                }
              }
            },
            '@media (min-width: 801px), print': {
              float: 'left',
              width: '51.43%',
              boxSizing: 'content-box',
              border: '0',
              color: 'inherit',
              margin: '0',
              padding: '0',
              ...mixins.boxSizing('content-box')
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                float: 'right'
              }
            }
          },
          '& $summary': {
            backgroundColor: '#f1f1f1',
            '@media (min-width: 801px), print': {
              width: '600px',
              margin: '0 auto',
              //width: '42.35%',
              border: '0',
              //margin: '0',
              padding: '0'
            },
            '& $header': {
              '&:after': {
                '@media (min-width: 801px), print': {
                  left: 0,
                  right: 0
                }
              }
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                float: 'left'
              }
            }
          },
          '@media (min-width: 801px), print': {
            ...mixins.boxSizing('content-box'),
            padding: '20px 30px',
            borderBottom: '1px solid #d8d8d8',
            overflow: 'hidden',
            boxSizing: 'content-box',
            color: 'inherit',
            margin: '0'
          }
        },
        '& $actionsContainer': {
          paddingTop: '20px',
          '& $actions': {
            borderTop: '1px solid #d8d8d8',
            '& $actionsGrid': {
              padding: '17px 10px 21px',
              display: 'table',
              margin: '0 auto',
              border: '0',
              color: 'inherit',
              ...mixins.boxSizing('content-box'),
              '& $actionContainer': {
                ...mixins.boxSizing('content-box'),
                borderRight: '1px solid #d8d8d8',
                display: 'table-cell',
                verticalAlign: 'middle',
                listStyle: 'none',
                color: 'inherit',
                margin: '0',
                padding: '0',
                '&:lang(ar)': {
                  borderRight: 'none',
                  borderLeft: '1px solid #d8d8d8'
                },
                '&:last-child': {
                  border: '0'
                },
                '& $actionIconContainer': {
                  width: '63px',
                  height: '100%',
                  color: data => data.mainColor,
                  font: "25px 'Icons'",
                  cursor: 'pointer',
                  overflow: 'visible',
                  boxSizing: 'border-box',
                  fontSize: 'inherit',
                  outline: '0',
                  textAlign: 'center',
                  background: 'none',
                  '& $actionIcon': {
                    color: data => data.mainColor,
                    font: "25px 'Icons'"
                  }
                }
              },
              '@media (min-width: 801px), print': {
                padding: '28px'
              }
            },
            '@media (min-width: 801px), print': {
              border: 'none',
              float: 'left'
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                float: 'right'
              }
            }
          },
          '@media (min-width: 801px), print': {
            padding: 0,
            overflow: 'hidden'
          }
        },
        '@media (min-width: 801px), print': {
          maxWidth: '1000px',
          margin: '0 auto'
        }
      },
      '@media (min-width: 801px), print': {
        ...mixins.boxSizing('content-box'),
        padding: '0 20px 20px',
        boxSizing: 'content-box',
        border: '0',
        color: 'inherit',
        margin: '0'
      }
    },
    '& $roomsFullContainer': {
      font: data => '300 13px ' + data.fontFamily1,
      background: '#f1f1f1',
      textAlign: 'left',
      paddingBottom: '20px',
      '&:lang(ar)': {
        textAlign: 'right'
      },
      '& $roomsFull': {
        backgroundColor: '#fff',
        ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        ...mixins.boxSizing('content-box'),
        border: 0,
        color: 'inherit',
        padding: 0,
        '& $roomsResume': {
          borderBottom: '1px solid #d8d8d8',
          '& $roomsPhotos': {
            position: 'relative',
            '& > div': {
              paddingLeft: '20px',
              paddingRight: '20px',
              position: 'relative',
              '@media (min-width: 801px), print': {
                paddingLeft: '0',
                paddingRight: '0'
              }
            },
            '& > div:last-child': {
              '& > div': {
                '&:after': {
                  content: 'none'
                }
              }
            },
            '@media (min-width: 801px), print': {
              float: 'left',
              width: '294px',
              boxSizing: 'content-box',
              border: '0',
              color: 'inherit',
              margin: '0',
              padding: '0',
              ...mixins.boxSizing('content-box'),
              height: '190px',
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                float: 'right'
              }
            },
            '& > button':{
              height: '100%',
            }
          },
          '& $roomsInfo': {
            padding: '16px 20px 16px',
            '& $buttonImage': {
              position: 'absolute',
              top: '0',
              left: '0',
              right:'0',
              bottom:'0',
              '@media (min-width:901px)': {
                width:'100%',
                height:'310px'
              },
            },
            '& $roomsTitle': {
              fontWeight: '500',
              fontSize: '16px',
              position: 'relative',
            },
            '@media (min-width: 801px), print': {
              float: 'right',
              width: 'calc(93.78% - 294px)',
              border: '0',
              margin: '0',
              padding: '0'
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                float: 'left'
              }
            },
            '& $roomDescriptionMargin':{
              marginTop: '20px',
            }
          },
          '@media (min-width: 801px), print': {
            ...mixins.boxSizing('content-box'),
            padding: '20px 30px',
            overflow: 'hidden',
            boxSizing: 'content-box',
            color: 'inherit',
            margin: '0'
          }
        },
        '@media (min-width: 801px), print': {
          maxWidth: '1000px',
          margin: '0 auto'
        }
      },
      '@media (min-width: 801px), print': {
        ...mixins.boxSizing('content-box'),
        padding: '0 20px 20px',
        boxSizing: 'content-box',
        border: '0',
        color: 'inherit',
        margin: '0'
      }
    },
    '& $paymentAndPenaltiesContainer': {
      font: data => '300 13px ' + data.fontFamily1,
      background: '#f1f1f1',
      textAlign: 'left',
      paddingBottom: '20px',
      '&:lang(ar)': {
        textAlign: 'right'
      },
      '& $paymentAndPenalties': {
        backgroundColor: '#fff',
        ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        '& $penaltiesBox': {
          '& $penaltiesTitle': {
            padding: '12px 20px 13px',
            borderBottom: '1px solid #d8d8d8',
            '& > span': {
              font: data => '18px ' + data.fontFamily2,
              '@media (min-width: 801px), print': {
                fontSize: '24px',
                fontWeight: '300'
              }
            },
            '@media (min-width: 801px), print': {
              padding: '0',
              borderBottomWidth: '0'
            }
          },
          '& $penaltiesText': {
            padding: '16px 20px 4px',
            lineHeight: '1.38',
            '@media (min-width: 801px), print': {
              padding: '16px 0 0'
            }
          },
          '@media (min-width: 801px), print': {
            display: 'table-cell',
            width: '50%',
            verticalAlign: 'top',
            padding: '0 30px 0'
          }
        },
        '& $paymentBox': {
          paddingBottom: '16px',
          '& $paymentTitle': {
            padding: '12px 20px 13px',
            borderBottom: '1px solid #d8d8d8',
            '& > span': {
              font: data => '18px ' + data.fontFamily2,
              '@media (min-width: 801px), print': {
                fontSize: '24px',
                fontWeight: '300'
              }
            },
            '@media (min-width: 801px), print': {
              padding: '0',
              borderBottomWidth: '0'
            }
          },
          '& $paymentText': {
            padding: '16px 20px 4px',
            lineHeight: '1.38',
            '@media (min-width: 801px), print': {
              padding: '16px 0 0'
            }
          },
          '@media (min-width: 801px), print': {
            display: 'table-cell',
            width: '50%',
            verticalAlign: 'top',
            padding: '0 30px 0',
            borderLeft: '1px solid #d8d8d8'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px)': {
              borderRight: 'none',
              borderLeft: '1px solid #d8d8d8'
            }
          }
        },
        '@media (min-width: 801px), print': {
          maxWidth: '1000px',
          margin: '0 auto',
          display: 'table',
          padding: '22px 0 18px',
          width:'100%'
        }
      },
      '@media (min-width: 801px), print': {
        padding: '0 20px 20px'
      }
    },
    '& $hotelInfoContainer': {
      position: 'relative',
      background: '#f1f1f1',
      paddingBottom: '20px',
      '& $hotelInfoBox': {
        position: 'relative',
        font: data => '300 13px ' + data.fontFamily1,
        ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        background: '#fff',
        boxSizing:'border-box',
        '& $hotelImage': {
          position: 'absolute',
          top: '20px',
          left: '20px',
          right: '20px',
          height: '160px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          '@media (min-width: 801px), print': {
            top: '30px',
            left: '30px',
            width: '360px',
            height: '280px',
            right: 'auto'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px)': {
              right: '30px',
              left: 'auto'
            }
          }
        },
        '& $hotelInfo': {
          padding: '190px 20px 20px',
          '& $hotelHeader': {
            '& $hotelOpinion': {
              float: 'right',
              '&:lang(ar)': {
                float: 'left'
              },
              '& $smile': {
                position: 'relative',
                padding: '2px 4px 2px 10px',
                border: '1px solid #5ca70a',
                fontSize: '16px',
                color: data => data.secondColor,
                ...mixins.mixinBorderRadius('3px'),
                '&:lang(ar)': {
                  paddingRight: '10px',
                  paddingLeft: '4px',
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  '@media (min-width: 801px)': {
                    paddingRight: '10px',
                    paddingLeft: '13px'
                  }
                },
                '& > span': {
                  marginRight: '5px',
                  '&:lang(ar)': {
                    marginLeft: '5px',
                    marginRight: '0',
                    '@media (min-width: 801px)': {
                      marginLeft: '8px',
                      marginRight: '0'
                    }
                  },
                  ' @media (min-width: 801px)': {
                    padding: '2px 4px 2px 15px'
                  }
                },
                '&:before': {
                  '@media (min-width: 801px), print': {
                    left: '15px',
                    fontSize: '17px'
                  }
                },
                '@media (min-width: 801px)': {
                  padding: '5px 13px 5px 10px',
                  fontSize: '17px'
                }
              }
            },
            '& $hotelTitle': {
              marginBottom: '10px',
              padding: '15px 0',
              borderBottom: '1px solid #d8d8d8',
              '& $hotelName': {
                fontSize: '16px',
                fontWeight: '500',
                lineHeight: '1.25',
                '@media (min-width: 801px), print': {
                  fontSize: '24px'
                },
                '&:lang(ar)': {
                  textAlign: 'right',
                },
              },
              '& $hotelInfoAddress': {
                marginTop: '2px',
                lineHeight: '1.38',
                color: '#666',
                '@media (min-width: 801px), print': {
                  fontSize: '13px'
                },
                '&:lang(ar)': {
                  textAlign: 'right',
                },
              },
              '@media (min-width: 801px), print': {
                paddingTop: '0'
              }
            },
            '&:lang(ar)': {
              '& $stars': {
                display: 'flex',
                flexDirection: 'row-reverse',
              }
            }
          },
          '& $hotelData': {
            border: '0',
            color: 'inherit',
            margin: '0',
            padding: '0',
            ...mixins.boxSizing('content-box'),
            '*': {
              margin: '0'
            },
            '& $hotelDataTable': {
              ...mixins.boxSizing('content-box'),
              display: 'table',
              width: '100%',
              border: '0',
              color: 'inherit',
              margin: '0',
              padding: '0',
              '& $hotelDataRow': {
                ...mixins.boxSizing('content-box'),
                display: 'table-row',
                listStyle: 'none',
                border: '0',
                color: 'inherit',
                margin: '0',
                padding: '0',
                '& $hotelDataCell': {
                  ...mixins.boxSizing('content-box'),
                  display: 'table-cell',
                  lineHeight: '1.85',
                  verticalAlign: 'top',
                  border: '0',
                  color: 'inherit',
                  margin: '0',
                  padding: '0',
                  '@media (min-width: 801px), print': {
                    ...mixins.boxSizing('content-box'),
                    border: '0',
                    color: 'inherit',
                    margin: '0',
                    padding: '0',
                    display: 'table-cell',
                    lineHeight: '1.85',
                    verticalAlign: 'top'
                  }
                },
                '@media (min-width: 801px), print': {
                  ...mixins.boxSizing('content-box'),
                  border: '0',
                  color: 'inherit',
                  margin: '0',
                  padding: '0',
                  display: 'table-row',
                  listStyle: 'none'
                }
              },
              '@media (min-width: 801px), print': {
                ...mixins.boxSizing('content-box'),
                border: '0',
                color: 'inherit',
                margin: '0',
                padding: '0',
                display: 'table',
                width: '100%'
              }
            },
            '@media (min-width: 801px), print': {
              ...mixins.boxSizing('content-box'),
              border: '0',
              color: 'inherit',
              margin: '0',
              padding: '0'
            },
            '&:lang(ar)': {
              direction: 'rtl'
            }
          },
          '@media (min-width: 801px), print': {
            minHeight: '280px',
            padding: '0 0 0 390px',
            marginBottom: '30px'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px), print': {
              paddingRight: '390px',
              paddingLeft: 0
            }
          }
        },
        '& $hotelMap': {
          ...mixins.boxSizing('content-box'),
          marginBottom: '15px',
          padding: '0 20px',
          border: 0,
          color: 'inherit',
          height: '205px',
          '& $gmapMarkerIcon': {
            position: 'absolute',
            top: '-45px',
            left: '-30px',
            display: 'block',
            ...mixins.boxSizing(),
            background: "url('/assets/icons/gmapmarker.png') no-repeat",
            width: '45px',
            height: '50px',
            paddingLeft: '45px',
            '&:lang(ar)': {
              left: "auto",
              right: "-30px",
              paddingLeft: "0",
              paddingRight: "45px"
            },
          },
          '@media (min-width: 801px), print': {
            marginBottom: '30px',
            padding: '0'
          }
        },
        '& $hotelOtherInfo': {
          paddingBottom: '20px',
          '& $hotelOtherInfoTitle': {
            padding: '0 10px 13px 20px',
            borderBottom: '1px solid #d8d8d8',
            '& > span': {
              font: data => '18px ' + data.fontFamily2,
              '@media (min-width: 801px), print': {
                fontSize: '24px',
                fontWeight: '300'
              }
            },
            '@media (min-width: 801px), print': {
              padding: '0 28px 13px 0'
            },
            '&:lang(ar)': {
              paddingRight: '20px',
              paddingLeft: '10px',
              textAlign: 'right',
              '@media (min-width: 801px), print': {
                paddingLeft: '28px',
                paddingRight: 0
              }
            }
          },
          '& $hotelOtherInfoText': {
            padding: '16px 20px 0',
            lineHeight: '1.38',
            '@media (min-width: 801px), print': {
              fontSize: '13px',
              paddingLeft: 0
            },
            '&:lang(ar)': {
              direction: 'rtl',
              '@media (min-width: 801px), print': {
                paddingRight: 0,
              }
            }
          },
          '@media (min-width: 801px), print': {
            padding: 0,
            display: 'table',
            width: '100%'
          }
        },
        '@media (min-width: 801px), print': {
          padding: '30px 30px 25px',
          fontSize: '16px',
          maxWidth: '1000px',
          margin: '0 auto'
        }
      },
      '@media (min-width: 801px), print': {
        padding: '0 20px 20px'
      }
    },
    '& $flightContainer': {
      background: '#f1f1f1',
      paddingBottom: '20px',
      '& $flightBox': {
        position: 'relative',
        padding: '13px',
        background: '#fff',
        ...mixins.boxShadow(' 0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        '& $flightInfo': {
          background: 'rgba(0, 17, 27, 0.72)',
          textAlign: 'center',
          color: '#fff',
          padding: '10px 14px 12px',
          '& $flightTitle': {
            font: data => '13px ' + data.fontFamily1,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginBottom: '10px'
          },
          '& $flightText': {
            font: data => '24px/1.25 ' + data.fontFamily2,
            marginBottom: '10px',
            '@media (min-width: 801px), print': {
              marginBottom: '32px'
            }
          },
          '& $flightButton': {
            '& > button': {
              ...mixins.boxSizing(),
              textDecoration: 'none',
              padding: '10px',
              display: 'block',
              width: '100%',
              background: data => data.secondColor,
              border: data => '1px solid ' + data.secondColor,
              height: 'auto',
              '&:hover': {
                background: 'transparent',
                transition: '0.3s',
                '& > span': {
                  color: data => data.secondColor
                }
              },
              '@media (min-width: 801px), print': {
                minWidth: '150px',
                width: 'auto',
                display: 'inline-block',
                padding: '15px'
              }
            }
          },
          '@media (min-width: 801px), print': {
            ...mixins.boxSizing('content-box !important'),
            maxWidth: '280px',
            margin: '0 0 0 auto',
            padding: '44px 20px 43px'
          }
        },
        '@media (min-width: 801px), print': {
          maxWidth: '1000px',
          margin: '0 auto',
          padding: '15px'
        }
      },
      '@media (min-width: 801px), print': {
        padding: '0 20px 20px'
      }
    },
    '& $corporateContainer': {
      background: '#f1f1f1',
      paddingBottom: '20px',
      '& $corporateBox': {
        font: data => '16px ' + data.fontFamily1,
        background: '#00111b',
        color: '#fff',
        textAlign: 'center',
        padding: '37px 20px 10px',
        backgroundSize: '720px',
        backgroundPosition: 'center top',
        backgroundPositionX: 'calc(20% - 10px)',
        backgroundRepeat: 'no-repeat',
        '& $corporateTitle': {
          font: data => '24px/1.25 ' + data.fontFamily2,
          maxWidth: '220px',
          margin: '0 auto',
          '@media (min-width: 801px)': {
            maxWidth: '725px'
          }
        },
        '& $corporateSupTitle': {
          font: data => '13px ' + data.fontFamily1,
          marginBottom: '7px',
          textTransform: 'uppercase',
          letterSpacing: '.5px',
          '@media (min-width: 801px)': {
            display: 'none'
          }
        },
        '& $corporateList': {
          maxWidth: '253px',
          margin: '37px auto 0',
          '& $corporateItem': {
            marginBottom: '18px',
            width: '47%',
            display: 'inline-block',
            verticalAlign: 'top',
            '& $corporateIcon': {
              display: 'none',
              '@media (min-width: 801px)': {
                display: 'block',
                fill: '#00111b',
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '0',
                left: '50%',
                padding: '9px',
                marginLeft: '-21px',
                background: '#fff',
                ...mixins.mixinBorderRadius('50%'),
                overflow: 'visible'
              },
              '&:lang(ar)': {
                '@media (min-width: 801px)': {
                  left: 'auto',
                  right: '50%',
                  marginRight: '-21px',
                  marginLeft: 0
                }
              }
            },
            '&:nth-of-type(odd) ': {
              marginRight: '5px',
              '@media (min-width: 801px)': {
                marginRight: '27px'
              },
              '&:lang(ar)': {
                marginLeft: '5px',
                marginRight: 0,
                '@media (min-width: 801px)': {
                  marginLeft: '27px',
                  marginRight: 0
                }
              }
            },
            '@media (min-width: 801px)': {
              display: 'inline-block',
              marginRight: '27px',
              width: 'calc(100%/6 - 27px)',
              position: 'relative',
              paddingTop: '45px'
            },
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                marginLeft: '27px',
                marginRight: 0
              }
            }
          },
          '@media (min-width: 801px)': {
            maxWidth: 'none',
            padding: '0 80px',
            margin: '20px 0 0'
          }
        },
        '@media (min-width: 801px)': {
          ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
          padding: '20px 20px 5px',
          maxWidth: '960px',
          margin: '0 auto',
          backgroundPosition: 'center',
          backgroundSize: '1200px'
        }
      },
      '@media (min-width: 801px)': {
        padding: '0 20px 20px'
      }
    },
    '& $webAdvantagesContainer': {
      background: '#f1f1f1',
      paddingBottom: '20px',
      '& $webAdvantagesBox': {
        font: data => '12px ' + data.fontFamily1,
        backgroundColor: '#FFF',
        textAlign: 'center',
        padding: '18px 20px 33px',
        ...mixins.boxShadow('0 3px 4px rgba(0, 0, 0, 0.3)'),
        boxSizing:'border-box',
        '@media (min-width: 801px)': {
          ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
          padding: '40px 40px',
          maxWidth: '1000px',
          margin: '0 auto',
          alignItems: 'center',
        },
        '& $activateText': {
          maxWidth: '550px',
          margin: '0 auto',
          '& $activateTitle':{
            font: data => 'bold 24px ' + data.fontFamily1,
            color: '#857550',
            '@media (min-width: 801px)': {
              fontSize: '34px',
            }
          },
          '& $activateSubTitle':{
            font: data => '14px ' + data.fontFamily1,
            padding: '15px 20px 2px',
            lineHeight: '1.38',
            '@media (min-width: 801px)': {
              fontSize: '16px',
              padding: '15px 0 0'
            }
          },
        },
        '& $webAdvantages': {
          font: data => '12px ' + data.fontFamily1,
          backgroundColor: '#FFF',
          color: '#857550',
          textAlign: 'center',
          padding: '18px 20px 33px',
          boxSizing:'border-box',
          display: 'flex',
          flexDirection: 'column',
          '& $webAdvantagesTitle': {
            font: data => 'bold 20px ' + data.fontFamily1,
            maxWidth: '220px',
            margin: '0 auto',
            '& svg': {
              marginBottom: '15px',
              '@media (min-width: 801px)': {
                minWidth: '290px',
              }
            },
            '& $webAdvantagesTitleHeader': {
              display: 'block',
              '@media (min-width: 801px)': {
                display: 'none'
              }
            },
            '@media (min-width: 801px)': {
              maxWidth: '725px',
            }
          },
          '& $webAdvantagesList': {
            margin: '23px auto 0',
            display: 'flex',
            justifyContent: 'space-between',
            '&:lang(ar)': {
              '@media (min-width: 801px)': {
                textAlign: 'right'
              }
            },
            '& $webAdvantagesItem': {
              position: 'relative',
              marginBottom: '15px',
              letterSpacing: '0.3px',
              color: '#000',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              '& svg': {
                maxWidth: '35px',
                minWidth: '35px',
                maxHeight: '35px',
                minHeight: '35px',
                marginBottom: '10px',
                fill: data => data.mainColor,
                '@media (min-width: 801px)': {
                  maxWidth: '50px',
                  minWidth: '50px',
                  maxHeight: '50px',
                  minHeight: '50px',
                },
              },
              '& $webAdvantagesIcon': {
                display: 'none'
              },
              '&:nth-of-type(odd)': {
                marginRight: '5px',
                '&:lang(ar)': {
                  '@media (min-width: 801px)': {
                    marginLeft: '5px',
                    marginRight: 0
                  }
                }
              },
              '&:after': {
                ...mixins.mixinBorderRadius('50%'),
                color: data => data.mainColor,
                font: "24px/42px 'Icons'",
                left: '0',
                top: '50%',
                marginTop: '-21px',
                position: 'absolute',
                width: '42px',
                height: '42px',
                textAlign: 'center',
                background: '#fff',
                '&:lang(ar)': {
                  '@media (min-width: 801px)': {
                    left: 'auto',
                    right: 0
                  }
                }
              },
              '&$itemBreakfast': {
                '&:after': {
                  content: "'e156'"
                }
              },
              '&$itemCheckin': {
                '&:after': {
                  content: "'e155'"
                }
              },
              '&$itemWelcomeWater': {
                '&:after': {
                  content: "'e157'"
                }
              },
              '@media (min-width: 801px)': {
                ...mixins.boxSizing(),              
                verticalAlign: 'middle',
                marginBottom: '0',
                width: '32%',
              },
              '&:lang(ar)': {
                paddingRight: '52px',
                paddingLeft: '0'
              }
            },
            '@media (min-width: 901px)': {
              maxWidth: '725px',
              marginTop: '14px',
              
              maxHeight: '100px',
              /* alignItems: 'center', */
            }
          },
          '&$webAdvantagesTitleNoLogo': {
            backgroundImage: 'none',
            padding: '30px 20px 12px'
          },
          '@media (min-width: 801px)': {
            padding: '40px 40px',
            alignItems: 'center',
            gap: '40px',
            fontSize: '16px',
            flexDirection: 'unset',
          }
        },
      },
      '@media (min-width: 801px)': {
        padding: '0 20px 20px'
      }
    },
    '& $mapImageConfirmation': {
      height: '205px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      display: 'block'
    },
    '& $userNotesContainer': {
      font: data => '300 13px ' + data.fontFamily1,
      background: '#f1f1f1',
      textAlign: 'left',
      paddingBottom: '20px',
      '&:lang(ar)': {
        textAlign: 'right'
      },
      '& $userNotes': {
        ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        background: '#fff',
        paddingBottom: '20px',
        '& $userNotesTitle': {
          padding: '12px 20px 13px',
          borderBottom: '1px solid #d8d8d8',
          '& > span': {
            font: data => '300 13px' + data.fontFamily1,
            '&.travelPointsTitle':{
              font: '300 18px DroidSerif',
              '@media (min-width: 801px)': {
                fontSize: '24px',
              }
            }
          },
          '@media (min-width: 801px), print': {
            border: '0',
            padding: '22px 30px 15px',
            font: data => '8px' + data.fontFamily2,
            ...mixins.boxSizing('content-box'),
            color: 'inherit',
            margin: '0'
          }
        },
        '& $userNotesText': {
          padding: '16px 20px 4px',
          lineHeight: '1.38',
          '@media (min-width: 801px), print': {
            ...mixins.boxSizing('content-box'),
            padding: '0 30px 20px',
            lineHeight: '1.38',
            border: '0',
            color: 'inherit',
            margin: '0'
          }
        },
        '@media (min-width: 801px), print': {
          maxWidth: '1000px',
          margin: '0 auto',
          background: '#fff',
          ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
          ...mixins.boxSizing('content-box'),
          border: '0',
          color: 'inherit',
          padding: '0'
        }
      },
      '@media (min-width: 801px)': {
        padding: '0 20px 20px',
        font: data => '300 13px' + data.fontFamily1,
        background: '#f1f1f1',
        textAlign: 'left',
        ...mixins.boxSizing('content-box'),
        border: '0',
        color: 'inherit',
        margin: '0'
      }
    },
    '& $confirmationContainer':{
      background: '#f1f1f1',
      paddingBottom: '20px',
      '& $confirmationBox':{
        position: 'relative',
        padding: '13px',
        background: '#fff',
        ...mixins.boxShadow(' 0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
        boxSizing:'border-box',
        '& $confirmationContent':{
          backgroundColor:'#dddde1',
          padding:'10px',
          boxSizing:'border-box',
          '& $confirmationList':{
            '& $confirmationElement':{
              display:'inline-block',
              verticalAlign:'top',
              width: 'calc(50% - 55px)',
              position:'relative',
              padding:'5px 5px 5px 50px',
              '& > span':{
                color:'black',
                display:'block',
                '@media (min-width: 801px), print': {
                  fontSize:'13px'
                }
              },
              '@media (min-width: 801px), print': {
                width: 'calc(33% - 54px)',
                padding:'9px 5px 9px 50px',
              },
              '& $confirmationElementSvg':{
                width:'50px',
                marginTop:'-25px',
                fill:'#b89c81',
                position:'absolute',
                left:'0',
                top:'50%',
              }
            },
            '@media (min-width: 801px), print': {
              display:'table-cell',
              verticalAlign:'middle'
            }
          },
          '& $confirmationLogo':{
            paddingTop:'7px',
            paddingBottom:'15px',
            textAlign:'center',
            '& $confirmationLogoSvg':{
              height:'82px',
              '& path':{
                '&.st0':{
                  fill:'#b89c81'
                },
                '&.st1':{
                  fill:'#656565'
                }
              },
              '@media (min-width: 801px), print': {
                height:'120px'
              }
            },
            '@media (min-width: 801px), print': {
              width:'250px',
              verticalAlign:'middle',
              display:'table-cell',
              paddingBottom:'0',
              paddingTop:'0'
            }
          },
          '@media (min-width: 801px), print': {
            padding:'20px',
            display:'table',
            width:'100%'
          }
        },
        '& $confirmationFooter':{
          padding:'10px',
          backgroundColor:'#919191',
          boxSizing:'border-box',
          '& $confirmationFooterCell':{
            textAlign:'center',
            '&:last-of-type':{
              paddingTop:'10px',
              '@media (min-width: 801px), print': {
                textAlign:'right',
                paddingTop:0
              }
            },
            '@media (min-width: 801px), print': {
              display:'table-cell',
              verticalAlign:'middle',
              textAlign:'left'
            },
            '& $confirmationFooterButton':{
              backgroundColor:'#d1bd9f',
              borderColor:'#d1bd9f',
              '& $confirmationFooterButtonText':{
                color:'#4e4e4e',
                font: "16px 'Droid Serif'",
              },
              '&:hover':{
                backgroundColor:'transparent',
                '& $confirmationFooterButtonText':{
                  color:'#d1bd9f'
                }
              }
            },
            '& > span':{
              '@media (min-width: 801px), print': {
                fontSize:'18px'
              }
            }
          },
          '@media (min-width: 801px), print': {
            padding:'10px 20px',
            display:'table',
            width:'100%',
          }
        },
        '@media (min-width: 801px), print': {
          maxWidth: '1000px',
          margin: '0 auto',
          padding: '15px'
        }
      },
      '@media (min-width: 801px), print': {
        padding: '0 20px 20px'
      }
    },
    '& $firstLetterUpper': {
      display: 'inline-block',
      '&:first-letter':{
        textTransform: 'capitalize',
      }
    },
    '& $bookerSendError': {
      color: '#f00',
      marginTop: '5px',
      display: 'block',
    },
    '& $bookerSendSucces': {
      marginTop: '5px',
      display: 'block',
    },
  },
};